/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminWebhookVisibilityGetAdminWebhooksEventsParams,
  LinkedApiRequestDto,
  PagedResultOfWebhookEventSummaryDto,
  WebhookDeliveryDto,
  WebhookEventDetailDto,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Paged list of inbound Adyen webhook events with per-status delivery counts.
 */
export const adminWebhookVisibilityGetAdminWebhooksEvents = (
  params?: AdminWebhookVisibilityGetAdminWebhooksEventsParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PagedResultOfWebhookEventSummaryDto>(
    { url: `/admin/webhooks/events`, method: 'GET', params, signal },
    options,
  );
};

export const getAdminWebhookVisibilityGetAdminWebhooksEventsQueryKey = (
  params?: AdminWebhookVisibilityGetAdminWebhooksEventsParams,
) => {
  return [`/admin/webhooks/events`, ...(params ? [params] : [])] as const;
};

export const getAdminWebhookVisibilityGetAdminWebhooksEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
  TError = unknown,
>(
  params?: AdminWebhookVisibilityGetAdminWebhooksEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminWebhookVisibilityGetAdminWebhooksEventsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>
  > = ({ signal }) => adminWebhookVisibilityGetAdminWebhooksEvents(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminWebhookVisibilityGetAdminWebhooksEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>
>;
export type AdminWebhookVisibilityGetAdminWebhooksEventsQueryError = unknown;

export function useAdminWebhookVisibilityGetAdminWebhooksEvents<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
  TError = unknown,
>(
  params: undefined | AdminWebhookVisibilityGetAdminWebhooksEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
          TError,
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWebhookVisibilityGetAdminWebhooksEvents<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
  TError = unknown,
>(
  params?: AdminWebhookVisibilityGetAdminWebhooksEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
          TError,
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWebhookVisibilityGetAdminWebhooksEvents<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
  TError = unknown,
>(
  params?: AdminWebhookVisibilityGetAdminWebhooksEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Paged list of inbound Adyen webhook events with per-status delivery counts.
 */

export function useAdminWebhookVisibilityGetAdminWebhooksEvents<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
  TError = unknown,
>(
  params?: AdminWebhookVisibilityGetAdminWebhooksEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminWebhookVisibilityGetAdminWebhooksEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Detail for one webhook event including every per-endpoint delivery row.
 */
export const adminWebhookVisibilityGetAdminWebhooksEventsIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookEventDetailDto>(
    { url: `/admin/webhooks/events/${id}`, method: 'GET', signal },
    options,
  );
};

export const getAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidQueryKey = (id?: string) => {
  return [`/admin/webhooks/events/${id}`] as const;
};

export const getAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>
  > = ({ signal }) =>
    adminWebhookVisibilityGetAdminWebhooksEventsIdGuid(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminWebhookVisibilityGetAdminWebhooksEventsIdGuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>
>;
export type AdminWebhookVisibilityGetAdminWebhooksEventsIdGuidQueryError = unknown;

export function useAdminWebhookVisibilityGetAdminWebhooksEventsIdGuid<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWebhookVisibilityGetAdminWebhooksEventsIdGuid<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWebhookVisibilityGetAdminWebhooksEventsIdGuid<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Detail for one webhook event including every per-endpoint delivery row.
 */

export function useAdminWebhookVisibilityGetAdminWebhooksEventsIdGuid<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Re-queue a single Failed/Abandoned delivery. Idempotent.
 */
export const adminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplay = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookDeliveryDto>(
    { url: `/admin/webhooks/deliveries/${id}/replay`, method: 'POST', signal },
    options,
  );
};

export const getAdminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplayMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplay>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplay>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplay'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplay>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplay(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplayMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplay>>
  >;

export type AdminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplayMutationError = unknown;

/**
 * @summary Re-queue a single Failed/Abandoned delivery. Idempotent.
 */
export const useAdminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplay = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplay>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplay>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getAdminWebhookVisibilityPostAdminWebhooksDeliveriesIdGuidReplayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Re-queue every Failed/Abandoned delivery for the event.
 */
export const adminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailed = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookEventDetailDto>(
    { url: `/admin/webhooks/events/${id}/replay-failed`, method: 'POST', signal },
    options,
  );
};

export const getAdminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailedMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailed>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailed>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailed'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailed>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailed(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailedMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailed>>
  >;

export type AdminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailedMutationError = unknown;

/**
 * @summary Re-queue every Failed/Abandoned delivery for the event.
 */
export const useAdminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailed = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailed>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailed>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getAdminWebhookVisibilityPostAdminWebhooksEventsIdGuidReplayFailedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List the api_requests rows whose captured pspReference matches this webhook event. Empty when no linkage exists (paymentMethods, sessions, or pre-capture events).
 */
export const adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<LinkedApiRequestDto[]>(
    { url: `/admin/webhooks/events/${id}/api-requests`, method: 'GET', signal },
    options,
  );
};

export const getAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequestsQueryKey = (
  id?: string,
) => {
  return [`/admin/webhooks/events/${id}/api-requests`] as const;
};

export const getAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequestsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>
  > = ({ signal }) =>
    adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>
>;
export type AdminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequestsQueryError = unknown;

export function useAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
          TError,
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
          TError,
          Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the api_requests rows whose captured pspReference matches this webhook event. Empty when no linkage exists (paymentMethods, sessions, or pre-capture events).
 */

export function useAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests<
  TData = Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminWebhookVisibilityGetAdminWebhooksEventsIdGuidApiRequestsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
